<script lang="ts">
	import type { Device } from 'src/types/Device';
	import { format } from 'src/services/i18n';
	import { Toggle } from '@Shelly/shelly-design-system';
	import { getCameraConfig, saveCameraConfig } from '../../helpers/camera-settings-helpers';

	export let device: Device;

	let enabled = getCameraConfig(device)?.led?.enable ?? false;
	let loading = false;

	const handleToggle = async () => {
		if (loading) return;
		enabled = !enabled;
		loading = true;
		const success = await saveCameraConfig(
			device,
			{ led: { enable: enabled } },
			enabled
				? $format('camera_status_led_enabled_toast', { default: 'Status LED enabled.' })
				: $format('camera_status_led_disabled_toast', { default: 'Status LED disabled.' }),
		);
		if (!success) {
			enabled = !enabled;
		}
		loading = false;
	};
</script>

<Toggle
	size="m"
	checked={enabled}
	disabled={loading}
	on:click={handleToggle}
	info={$format('camera_status_led_info', {
		default: 'Enable or disable the camera status LED indicator.',
	})}
	id="camera-status-led-enable"
>
	{$format('sub_settings_title_status_led', { default: 'Status LED' })}
</Toggle>
